module.exports = __webpack_public_path__ + "img/Default-course.02b13ef1.png";